// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276,9 12,15 18,9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quotation-history-page {
    background-color: #fff;
    font-family: 'Noto Sans KR', sans-serif;
}

.qhp-container {
    max-width: 1320px;
    margin: 0 auto;
    padding: 40px 20px;
}

.qhp-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.qhp-breadcrumb .current {
    color: #E84100;
    font-weight: 500;
}

.qhp-title {
    font-size: 36px;
    font-weight: bold;
    margin: 0 0 10px 0;
    color: #222;
}

.qhp-description {
    font-size: 16px;
    color: #555;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
}

.qhp-search-filters {
    border: 1px solid #ddd;
    padding: 20px;
    margin-bottom: 40px;
}

.filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.filter-row:last-child {
    margin-bottom: 0;
}

.filter-row label {
    flex-basis: 150px;
    font-weight: 500;
    color: #333;
}

.filter-row input[type="text"] {
    flex-grow: 1;
    max-width: 400px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.filter-row select {
    flex-grow: 1;
    max-width: 400px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
}

.filter-row select:focus {
    outline: none;
    border-color: #E84100;
    box-shadow: 0 0 0 2px rgba(232, 65, 0, 0.2);
}

.date-range-picker {
    display: flex;
    align-items: center;
    gap: 10px;
}

.date-range-picker input[type="date"] {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.date-filter {
    display: flex;
    align-items: center;
}

.date-button, .status-button {
    padding: 10px 20px;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
}
.date-button.active, .status-button.active {
    background-color: #f0f0f0;
    font-weight: bold;
    border-color: #999;
}

.date-link {
    margin-left: 10px;
    background: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    color: #555;
}

.status-filter {
    display: flex;
    gap: 10px;
}

.qhp-search-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.search-button, .reset-button {
    padding: 15px 60px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

.search-button {
    background-color: #E84100;
    color: #fff;
    border: none;
}

.reset-button {
    background-color: #fff;
    color: #333;
    border: 1px solid #ccc;
}

.quotation-card {
    border: 2px solid #e0e0e0;
    margin-bottom: 20px;
}

.quotation-header {
    display: grid;
    grid-template-columns: 50px 1fr auto;
    align-items: center;
    padding: 15px;
    background-color: #f9f9f9;
    font-weight: 500;
}

.quotation-header input[type="checkbox"] {
    width: 20px;
    height: 20px;
}

.header-labels {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    justify-items: center;
    width: 400px;
    font-size: 14px;
    color: #555;
}

.quotation-item {
    display: grid;
    grid-template-columns: 1fr 150px 150px 150px;
    align-items: center;
    padding: 20px 15px;
    border-top: 1px solid #eee;
}

.item-info {
    display: flex;
    align-items: center;
}

.item-image.image-placeholder, .item-image img {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
    margin-right: 15px;
    flex-shrink: 0;
}

.item-details p {
    margin: 0;
    line-height: 1.4;
}

.item-name {
    font-size: 16px;
    font-weight: bold;
}
.item-spec {
    font-size: 14px;
}
.item-option {
    font-size: 14px;
    color: #777;
}

.item-quantity, .item-delivery, .item-status {
    text-align: center;
}

.item-status p {
    font-weight: bold;
    margin: 0 0 5px 0;
}
.item-status a {
    color: #E84100;
    text-decoration: underline;
}

.qhp-bottom-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 40px;
}

.order-guide-button, .delete-button {
    padding: 15px 40px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

.order-guide-button {
    background-color: #E84100;
    color: #fff;
    border: none;
}

.delete-button {
    background-color: #222;
    color: #fff;
    border: none;
}

/* Adjusting grid to match image layout */
.quotation-header {
    display: flex;
    align-items: center;
    padding: 15px;
    gap: 15px;
}

.quotation-header > span {
    flex-grow: 1;
}

.header-labels {
    display: contents; /* This is tricky, let's try a different way */
}

.quotation-items {
    padding: 0;
}

.quotation-item {
    display: grid;
    grid-template-columns: 50px auto 150px 150px 150px; /* Checkbox, product, qty, delivery, status */
    padding: 20px 0;
    margin: 0 15px;
    align-items: center;
    gap: 15px;
}

.quotation-item:first-child {
    border-top: 1px solid #eee;
}

.quotation-item .item-info {
    grid-column: 2;
}
.quotation-item .item-quantity {
    grid-column: 3;
}
.quotation-item .item-delivery {
    grid-column: 4;
}
.quotation-item .item-status {
    grid-column: 5;
}


/* Re-thinking the list header inside the card */

.quotation-header {
    display: flex;
    align-items: center;
    padding: 15px;
    gap: 15px;
    background-color: #f9f9f9;
}

.quotation-header .header-labels {
    display: grid;
    grid-template-columns: auto 150px 150px 150px;
    flex-grow: 1;
    justify-items: center;
}
.header-labels span:first-child {
    justify-self: start;
    padding-left: 170px; /* Aligns with item image+text */
}

/* Let's simplify and fix the layout to be more robust */

.quotation-card {
    border: none;
    border-top: 2px solid #222;
}

.quotation-header {
    background-color: #f8f8f8;
    border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    padding: 15px;
    gap: 20px;
}

.quotation-header > input {
    margin: 0;
}

.quotation-header > span {
    font-weight: 500;
}

.quotation-list-header {
    display: grid;
    grid-template-columns: 1fr 150px 150px 150px;
    padding: 15px;
    font-weight: 500;
    color: #333;
    background-color: #f8f8f8;
    border-bottom: 1px solid #ddd;
}
.quotation-list-header span:first-child {
    text-align: center;
}

/* This is too complex. The header is part of the list, not the card. Let's restructure. */
/* The provided image shows the "제품명", "수량" headers are inside the gray bar. */

.qhp-quotation-list {
    border-top: 2px solid #222;
    border-bottom: 2px solid #222;
}

.quotation-card {
    border-bottom: 1px solid #ddd;
}
.quotation-card:last-child {
    border-bottom: none;
}

.quotation-header {
    display: flex;
    align-items: center;
    gap: 15px;
    background-color: #f8f8f8;
    padding: 15px;
    font-weight: 500;
}
.quotation-header .header-labels {
    margin-left: auto;
    display: grid;
    grid-template-columns: 150px 150px 150px 150px; /* 제품명,수량,희망납기,상태 - 제품명 is implicit*/
    gap: 20px;
    color: #333;
    font-weight: 500;
}

.quotation-header .header-labels span {
    text-align: center;
}


.quotation-item {
    display: flex;
    align-items: center;
    padding: 20px 15px;
    border-top: 1px solid #eee;
}

.item-info {
    flex: 1 1; /* takes up available space */
    display: flex;
    align-items: center;
}

.item-quantity, .item-delivery, .item-status {
    flex-basis: 150px;
    text-align: center;
}

.item-status a {
    font-size: 14px;
}

/* Final attempt at layout based on image */
.qhp-quotation-list {
    border-top: 2px solid #222;
    border-bottom: 2px solid #222;
}

.quotation-card {
    border-bottom: 1px solid #ddd;
}
.quotation-card:last-child {
    border-bottom: none;
}
.quotation-header {
    display: flex;
    align-items: center;
    background-color: #f8f8f8;
    padding: 15px;
    gap: 15px;
}
.quotation-header span {
    font-weight: 500;
}

.quotation-header .header-labels {
    margin-left: auto;
    display: grid;
    grid-template-columns: 150px 150px 150px 150px;
    text-align: center;
}

.quotation-items {
    /* No special styling needed */
}

.quotation-item {
    display: flex;
    padding: 20px 15px;
    align-items: center;
    gap: 15px;
}

.quotation-item:not(:first-child) {
    border-top: 1px solid #eee;
}


.item-info {
    flex: 1 1;
    display: flex;
    align-items: center;
    gap: 20px;
}

.item-details .item-name {
    font-size: 16px;
    font-weight: 500;
}
.item-details .item-spec, .item-details .item-option {
    font-size: 14px;
    color: #666;
}

.item-quantity, .item-delivery {
    width: 150px;
    text-align: center;
}

.item-status {
    width: 150px;
    text-align: center;
}
.item-status p {
    font-weight: 500;
}
.item-status a {
    color: #E84100;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .qhp-container {
        padding: 20px;
    }

    .qhp-title {
        font-size: 30px;
    }

    .filter-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .filter-row label {
        flex-basis: auto;
    }

    .filter-row input[type="text"] {
        max-width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .qhp-container {
        padding: 15px;
    }

    .qhp-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
    }

    .qhp-title {
        font-size: 24px;
    }
    
    .qhp-description {
        font-size: 14px;
    }
    
    .date-filter {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    .date-link {
        margin-left: 0;
        text-align: center;
    }
    
    .status-filter {
        flex-wrap: wrap;
    }

    .search-button, .reset-button {
        width: 100%;
        padding: 12px;
    }
    
    .qhp-search-actions {
        flex-direction: column;
    }

    .quotation-header .header-labels {
       display: none;
    }

    .quotation-item {
        grid-template-columns: 1fr;
        gap: 15px;
        text-align: left;
    }

    .item-info {
       grid-column: 1 / -1;
    }

    .item-quantity, .item-delivery, .item-status {
        text-align: left;
    }

    .item-quantity::before, .item-delivery::before, .item-status::before {
        content: attr(data-label);
        font-weight: bold;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
    }

    .qhp-bottom-actions {
        flex-direction: column;
        gap: 10px;
    }

    .order-guide-button, .delete-button {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/QuotationHistoryPage.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,yDAA2R;IAC3R,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB,EAAE,8CAA8C;AACrE;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kDAAkD,EAAE,6CAA6C;IACjG,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;;AAGA,gDAAgD;;AAEhD;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6CAA6C;IAC7C,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,mBAAmB,EAAE,gCAAgC;AACzD;;AAEA,wDAAwD;;AAExD;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;;AAEA,0FAA0F;AAC1F,8EAA8E;;AAE9E;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,8CAA8C,EAAE,oCAAoC;IACpF,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,SAAO,EAAE,6BAA6B;IACtC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;OACG,aAAa;IAChB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,gBAAgB;IACpB;;IAEA;OACG,mBAAmB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;QACjB,qBAAqB;QACrB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".quotation-history-page {\n    background-color: #fff;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.qhp-container {\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 40px 20px;\n}\n\n.qhp-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.qhp-breadcrumb .current {\n    color: #E84100;\n    font-weight: 500;\n}\n\n.qhp-title {\n    font-size: 36px;\n    font-weight: bold;\n    margin: 0 0 10px 0;\n    color: #222;\n}\n\n.qhp-description {\n    font-size: 16px;\n    color: #555;\n    margin-bottom: 30px;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #eee;\n}\n\n.qhp-search-filters {\n    border: 1px solid #ddd;\n    padding: 20px;\n    margin-bottom: 40px;\n}\n\n.filter-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.filter-row:last-child {\n    margin-bottom: 0;\n}\n\n.filter-row label {\n    flex-basis: 150px;\n    font-weight: 500;\n    color: #333;\n}\n\n.filter-row input[type=\"text\"] {\n    flex-grow: 1;\n    max-width: 400px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.filter-row select {\n    flex-grow: 1;\n    max-width: 400px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    background-size: 16px;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    cursor: pointer;\n}\n\n.filter-row select:focus {\n    outline: none;\n    border-color: #E84100;\n    box-shadow: 0 0 0 2px rgba(232, 65, 0, 0.2);\n}\n\n.date-range-picker {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.date-range-picker input[type=\"date\"] {\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.date-filter {\n    display: flex;\n    align-items: center;\n}\n\n.date-button, .status-button {\n    padding: 10px 20px;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    cursor: pointer;\n}\n.date-button.active, .status-button.active {\n    background-color: #f0f0f0;\n    font-weight: bold;\n    border-color: #999;\n}\n\n.date-link {\n    margin-left: 10px;\n    background: none;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n    color: #555;\n}\n\n.status-filter {\n    display: flex;\n    gap: 10px;\n}\n\n.qhp-search-actions {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 30px;\n    padding-top: 20px;\n    border-top: 1px solid #eee;\n}\n\n.search-button, .reset-button {\n    padding: 15px 60px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.search-button {\n    background-color: #E84100;\n    color: #fff;\n    border: none;\n}\n\n.reset-button {\n    background-color: #fff;\n    color: #333;\n    border: 1px solid #ccc;\n}\n\n.quotation-card {\n    border: 2px solid #e0e0e0;\n    margin-bottom: 20px;\n}\n\n.quotation-header {\n    display: grid;\n    grid-template-columns: 50px 1fr auto;\n    align-items: center;\n    padding: 15px;\n    background-color: #f9f9f9;\n    font-weight: 500;\n}\n\n.quotation-header input[type=\"checkbox\"] {\n    width: 20px;\n    height: 20px;\n}\n\n.header-labels {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 20px;\n    justify-items: center;\n    width: 400px;\n    font-size: 14px;\n    color: #555;\n}\n\n.quotation-item {\n    display: grid;\n    grid-template-columns: 1fr 150px 150px 150px;\n    align-items: center;\n    padding: 20px 15px;\n    border-top: 1px solid #eee;\n}\n\n.item-info {\n    display: flex;\n    align-items: center;\n}\n\n.item-image.image-placeholder, .item-image img {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    margin-right: 15px;\n    flex-shrink: 0;\n}\n\n.item-details p {\n    margin: 0;\n    line-height: 1.4;\n}\n\n.item-name {\n    font-size: 16px;\n    font-weight: bold;\n}\n.item-spec {\n    font-size: 14px;\n}\n.item-option {\n    font-size: 14px;\n    color: #777;\n}\n\n.item-quantity, .item-delivery, .item-status {\n    text-align: center;\n}\n\n.item-status p {\n    font-weight: bold;\n    margin: 0 0 5px 0;\n}\n.item-status a {\n    color: #E84100;\n    text-decoration: underline;\n}\n\n.qhp-bottom-actions {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 40px;\n}\n\n.order-guide-button, .delete-button {\n    padding: 15px 40px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.order-guide-button {\n    background-color: #E84100;\n    color: #fff;\n    border: none;\n}\n\n.delete-button {\n    background-color: #222;\n    color: #fff;\n    border: none;\n}\n\n/* Adjusting grid to match image layout */\n.quotation-header {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    gap: 15px;\n}\n\n.quotation-header > span {\n    flex-grow: 1;\n}\n\n.header-labels {\n    display: contents; /* This is tricky, let's try a different way */\n}\n\n.quotation-items {\n    padding: 0;\n}\n\n.quotation-item {\n    display: grid;\n    grid-template-columns: 50px auto 150px 150px 150px; /* Checkbox, product, qty, delivery, status */\n    padding: 20px 0;\n    margin: 0 15px;\n    align-items: center;\n    gap: 15px;\n}\n\n.quotation-item:first-child {\n    border-top: 1px solid #eee;\n}\n\n.quotation-item .item-info {\n    grid-column: 2;\n}\n.quotation-item .item-quantity {\n    grid-column: 3;\n}\n.quotation-item .item-delivery {\n    grid-column: 4;\n}\n.quotation-item .item-status {\n    grid-column: 5;\n}\n\n\n/* Re-thinking the list header inside the card */\n\n.quotation-header {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    gap: 15px;\n    background-color: #f9f9f9;\n}\n\n.quotation-header .header-labels {\n    display: grid;\n    grid-template-columns: auto 150px 150px 150px;\n    flex-grow: 1;\n    justify-items: center;\n}\n.header-labels span:first-child {\n    justify-self: start;\n    padding-left: 170px; /* Aligns with item image+text */\n}\n\n/* Let's simplify and fix the layout to be more robust */\n\n.quotation-card {\n    border: none;\n    border-top: 2px solid #222;\n}\n\n.quotation-header {\n    background-color: #f8f8f8;\n    border-bottom: 1px solid #ddd;\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    gap: 20px;\n}\n\n.quotation-header > input {\n    margin: 0;\n}\n\n.quotation-header > span {\n    font-weight: 500;\n}\n\n.quotation-list-header {\n    display: grid;\n    grid-template-columns: 1fr 150px 150px 150px;\n    padding: 15px;\n    font-weight: 500;\n    color: #333;\n    background-color: #f8f8f8;\n    border-bottom: 1px solid #ddd;\n}\n.quotation-list-header span:first-child {\n    text-align: center;\n}\n\n/* This is too complex. The header is part of the list, not the card. Let's restructure. */\n/* The provided image shows the \"제품명\", \"수량\" headers are inside the gray bar. */\n\n.qhp-quotation-list {\n    border-top: 2px solid #222;\n    border-bottom: 2px solid #222;\n}\n\n.quotation-card {\n    border-bottom: 1px solid #ddd;\n}\n.quotation-card:last-child {\n    border-bottom: none;\n}\n\n.quotation-header {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    background-color: #f8f8f8;\n    padding: 15px;\n    font-weight: 500;\n}\n.quotation-header .header-labels {\n    margin-left: auto;\n    display: grid;\n    grid-template-columns: 150px 150px 150px 150px; /* 제품명,수량,희망납기,상태 - 제품명 is implicit*/\n    gap: 20px;\n    color: #333;\n    font-weight: 500;\n}\n\n.quotation-header .header-labels span {\n    text-align: center;\n}\n\n\n.quotation-item {\n    display: flex;\n    align-items: center;\n    padding: 20px 15px;\n    border-top: 1px solid #eee;\n}\n\n.item-info {\n    flex: 1; /* takes up available space */\n    display: flex;\n    align-items: center;\n}\n\n.item-quantity, .item-delivery, .item-status {\n    flex-basis: 150px;\n    text-align: center;\n}\n\n.item-status a {\n    font-size: 14px;\n}\n\n/* Final attempt at layout based on image */\n.qhp-quotation-list {\n    border-top: 2px solid #222;\n    border-bottom: 2px solid #222;\n}\n\n.quotation-card {\n    border-bottom: 1px solid #ddd;\n}\n.quotation-card:last-child {\n    border-bottom: none;\n}\n.quotation-header {\n    display: flex;\n    align-items: center;\n    background-color: #f8f8f8;\n    padding: 15px;\n    gap: 15px;\n}\n.quotation-header span {\n    font-weight: 500;\n}\n\n.quotation-header .header-labels {\n    margin-left: auto;\n    display: grid;\n    grid-template-columns: 150px 150px 150px 150px;\n    text-align: center;\n}\n\n.quotation-items {\n    /* No special styling needed */\n}\n\n.quotation-item {\n    display: flex;\n    padding: 20px 15px;\n    align-items: center;\n    gap: 15px;\n}\n\n.quotation-item:not(:first-child) {\n    border-top: 1px solid #eee;\n}\n\n\n.item-info {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.item-details .item-name {\n    font-size: 16px;\n    font-weight: 500;\n}\n.item-details .item-spec, .item-details .item-option {\n    font-size: 14px;\n    color: #666;\n}\n\n.item-quantity, .item-delivery {\n    width: 150px;\n    text-align: center;\n}\n\n.item-status {\n    width: 150px;\n    text-align: center;\n}\n.item-status p {\n    font-weight: 500;\n}\n.item-status a {\n    color: #E84100;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .qhp-container {\n        padding: 20px;\n    }\n\n    .qhp-title {\n        font-size: 30px;\n    }\n\n    .filter-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .filter-row label {\n        flex-basis: auto;\n    }\n\n    .filter-row input[type=\"text\"] {\n        max-width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .qhp-container {\n        padding: 15px;\n    }\n\n    .qhp-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    .qhp-title {\n        font-size: 24px;\n    }\n    \n    .qhp-description {\n        font-size: 14px;\n    }\n    \n    .date-filter {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 10px;\n    }\n\n    .date-link {\n        margin-left: 0;\n        text-align: center;\n    }\n    \n    .status-filter {\n        flex-wrap: wrap;\n    }\n\n    .search-button, .reset-button {\n        width: 100%;\n        padding: 12px;\n    }\n    \n    .qhp-search-actions {\n        flex-direction: column;\n    }\n\n    .quotation-header .header-labels {\n       display: none;\n    }\n\n    .quotation-item {\n        grid-template-columns: 1fr;\n        gap: 15px;\n        text-align: left;\n    }\n\n    .item-info {\n       grid-column: 1 / -1;\n    }\n\n    .item-quantity, .item-delivery, .item-status {\n        text-align: left;\n    }\n\n    .item-quantity::before, .item-delivery::before, .item-status::before {\n        content: attr(data-label);\n        font-weight: bold;\n        display: inline-block;\n        width: 100px;\n        margin-right: 10px;\n    }\n\n    .qhp-bottom-actions {\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .order-guide-button, .delete-button {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
